<template>
    <slot :hasHeaders="BstkCSVImportData.fileHasHeaders" :toggle="toggleHasHeaders">
        <label v-bind="labelAttributes">
            <input
                type="checkbox"
                v-bind="checkboxAttributes"
                :checked="BstkCSVImportData.fileHasHeaders"
                @change="toggleHasHeaders"
            >
            {{ labels.toggleHeaders }}
        </label>
    </slot>
</template>

<script>
    import {inject} from 'vue';

    /* eslint-disable */
    export default {
        name: "ToggleHasHeaders",
        props: {
            labelAttributes: {},
            checkboxAttributes: {},
        },
        setup() {
            const BstkCSVImportData = inject('BstkCSVImportData');
            const labels = BstkCSVImportData.language;

            const toggleHasHeaders = function () {
                BstkCSVImportData.fileHasHeaders = !BstkCSVImportData.fileHasHeaders;
            }

            return {
                BstkCSVImportData,
                toggleHasHeaders,
                labels
            }
        },
    };
</script>